import { render, staticRenderFns } from "./CardSourceChart.vue?vue&type=template&id=4ca0534f&"
import script from "./CardSourceChart.vue?vue&type=script&lang=js&"
export * from "./CardSourceChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports